import React, { useEffect, useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { Box, Divider, Grid, Typography } from '@material-ui/core'
import { components } from 'cng-web-lib'
import { useParams } from 'react-router-dom'
import pathMap from 'src/paths/pathMap'
import MpciApiClient from '../Common/services/MpciApiClient'
import UaeMpciApiUrls from 'src/apiUrls/UaeMpciApiUrls'
import FormProperties from './FormProperties'
import ParentCard from 'src/components/era-package/shared/ParentCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CngSection from 'src/components/cngcomponents/CngSection'
import { STATUS_CODES } from '../Common/constants/billStatuses'
import AuditHistoryTable from '../Common/components/AuditHistoryTable'


const {
  button: { CngButton }
} = components

function ViewPage({ history, showNotification }) {
  const { id } = useParams()
  const [isFetching, setIsFetching] = useState(false)
  const [recordStatus, setRecordStatus] = useState('')
  const [canEdit, setCanEdit] = useState(false)

  const methods = useForm({
    defaultValues: { ...FormProperties.formikProps.initialValues }
  })

    useEffect(() => {
    MpciApiClient.getById(
      UaeMpciApiUrls.MASTER_BILL_GET,
      id,
      (record) => {
        if (!record) {
          showNotification('error', 'Data not found.')
          history.push(pathMap.UAE_MPCI_MASTER_BILL_LIST_VIEW)
        } else {
          methods.reset(FormProperties.toClientDataFormat(record))
          setRecordStatus(record.status || '')
          setCanEdit(record.isEdit === 'true')
        }
        setIsFetching(true)
      },
      () => {
        showNotification('error', 'Failed to load record.')
        history.push(pathMap.UAE_MPCI_MASTER_BILL_LIST_VIEW)
        setIsFetching(true)
      }
    )
  }, [])

  if (!isFetching) return <p>Loading...</p>

  return (
    <ParentCard title='Master Bill of Lading'>
      <FormProvider {...methods}>
        <form>
          <FormProperties.Fields
            disabled={true}
            showNotification={showNotification}
            shouldHideMap={{}}
            isCreateMode={false}
          />

          <Box mt={3}>
            <Divider />
          </Box>

          {recordStatus !== STATUS_CODES.DRAFT && (
            <Box mt={3}>
              <CngSection title='Audit History'>
                <AuditHistoryTable id={id} />
              </CngSection>
            </Box>
          )}

          <Box mt={2}>
            <Grid container justify='space-between'>
              <Grid item>
                <CngButton
                  color='secondary'
                  size='medium'
                  onClick={() => history.push(pathMap.UAE_MPCI_MASTER_BILL_LIST_VIEW)}
                  startIcon={<FontAwesomeIcon icon={['fal', 'arrow-left']} />}
                >
                  Back to List
                </CngButton>
              </Grid>
              {([STATUS_CODES.CONTRL_ACK, STATUS_CODES.ACT, STATUS_CODES.ACW, STATUS_CODES.DNL, STATUS_CODES.EXP, STATUS_CODES.PSF, STATUS_CODES.RFI, STATUS_CODES.CANCEL_CONTRL_NACK, STATUS_CODES.ATTACH_ACK, STATUS_CODES.ATTACH_NACK].includes(recordStatus) ||
                ([STATUS_CODES.SUBM_ERR, STATUS_CODES.CONTRL_NACK].includes(recordStatus) && canEdit)) && (
                <Grid item>
                  <CngButton
                    color='primary'
                    size='medium'
                    onClick={() => history.push(`${pathMap.UAE_MPCI_MASTER_BILL}/edit/${id}`)}
                    startIcon={<FontAwesomeIcon icon={['fal', 'pen']} />}
                  >
                    Edit
                  </CngButton>
                </Grid>
              )}
            </Grid>
          </Box>
        </form>
      </FormProvider>
    </ParentCard>
  )
}

export default ViewPage
